var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSaveIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.9978 11.9973C9.88104 11.9982 9.76612 11.9683 9.66454 11.9107L5.33216 9.43125L0.999784 11.9107C0.898266 11.9693 0.783085 12.0001 0.665861 12C0.548637 11.9999 0.433517 11.9689 0.332114 11.91C0.230712 11.8512 0.146615 11.7667 0.0883055 11.665C0.0299966 11.5633 -0.000461175 11.4481 5.27823e-06 11.3308V1.33304C5.27823e-06 0.979495 0.14045 0.640431 0.390443 0.390438C0.640436 0.140445 0.9795 0 1.33304 0H9.33128C9.68482 0 10.0239 0.140445 10.2739 0.390438C10.5239 0.640431 10.6643 0.979495 10.6643 1.33304V11.3308C10.6643 11.5076 10.5941 11.6771 10.4691 11.8021C10.3441 11.9271 10.1746 11.9973 9.9978 11.9973Z",
    fill: "#2B96DC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveIco);
export default __webpack_public_path__ + "static/media/save-ico.9fe855cd83f2937fd78022f28351ff99.svg";
export { ForwardRef as ReactComponent };